import { useContext } from 'react';

import { ChainContext } from '../chain.context';

export const useChangeChain = () => {
  const context = useContext(ChainContext);
  if (!context) {
    throw new Error('useChangeChain must be used within a ChainProvider');
  }

  return context.changeChain;
};
